export const createNumberFieldSequencer = <T>(getter: (name: T) => number) => {
  return (a: T, b: T): number => getter(a) - getter(b);
};

export const createStringFieldSequencer = <T>(getter: (name: T) => string) => {
  return (a: T, b: T): number => getter(a).localeCompare(getter(b), 'en');
};

export const createDateFieldSequencer = <T>(getter: (name: T) => Date) => {
  return (a: T, b: T): number => getter(b).getTime() - getter(a).getTime();
};
